import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { ContractSearchPage } from "./contract-search.page";

const routes: Routes = [
    {
        path: "",
        component: ContractSearchPage,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ContractSearchPageRoutingModule {
}
